const requiredFieldsFive = ["prev_request"];

export default requiredFieldsFive;
